import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getActivityById = async (activityId, memberId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Activity/GetActivityById/${activityId}/${memberId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const updateActivityCompletionRecord = async (activityCompletionRecordModel) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Activity/UpdateActivityCompletionRecord`,
        data: activityCompletionRecordModel,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getActivityHistoryByMemberId = async (memberId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Activity/GetActivityHistoryByMemberId/${memberId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};